const theme = {
    blue: '#002666',
    lightBlue: '#009fea',
    softBlue: '#80a3c7',
    red: '#ce1720',
    yellow: '#ffb615',
    orange: '#e49300',
    brightGreen: '#00e024',
    softGreen: '#86c232',
    green: '#008d1f',
    black: '#0e0e0e',
    darkGray: '#232323',
    gray: '#535353',
    halfGray: '#6a6a6a',
    softGray: '#bbbbbb',
    lightGray: '#dfdede',
    dirtyWhite: '#efefef',
    ice: '#e5f0ff',
};

export default theme;
